import { render, staticRenderFns } from "./ToDoDialog.vue?vue&type=template&id=20c3a218&"
import script from "./ToDoDialog.vue?vue&type=script&lang=js&"
export * from "./ToDoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports